export const notifyParent = (action, data, { parent, document } = window) => {
  if (process.env.NODE_ENV !== 'production') {
    if (parent === top) {
      // eslint-disable-next-line no-console
      console.log(
        '%cnotifyParent',
        'color: purple; font-weight:bold',
        action,
        data
      )
    }
  }

  parent && parent.postMessage({ action, data }, getTargetOrigin(document))
}

export const notifyOpener = (action, data, { parent, document } = window) => {
  const target = window.opener ? window.opener.parent : parent
  if (process.env.NODE_ENV !== 'production') {
    if (parent === top) {
      // eslint-disable-next-line no-console
      console.log(
        '%notifyOpener',
        'color: purple; font-weight:bold',
        action,
        data
      )
    }
  }

  target && target.postMessage({ action, data }, getTargetOrigin(document))
}

function getTargetOrigin({ location } = document) {
  let origin = ''
  try {
    origin = location.ancestorOrigins[0]
  } catch (err) {
    origin = '*'
  }
  return origin !== undefined ? origin : '*'
}

export const notifyFrame = (
  frameName,
  action,
  data,
  { document, frames } = window
) => {
  const targetFrame = frames[frameName]
  if (targetFrame) {
    targetFrame.postMessage({ action, data }, getTargetOrigin(document))
  }
}
